import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Platforms = lazy(() => import('../pages/platforms/page'));
const Features = lazy(() => import('../pages/features/page'));
const Resources = lazy(() => import('../pages/resources/page'));
const Marketplace = lazy(() => import('../pages/marketplace/page'));
const Partners = lazy(() => import('../pages/partners/page'));
const Support = lazy(() => import('../pages/support/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const About = lazy(() => import('../pages/about/page'));
const Login = lazy(() => import('../pages/login/page'));
const AdminContent = lazy(() => import('../pages/admin/content/page'));
const AdminNews = lazy(() => import('../pages/admin/news/page'));
const AdminEmail = lazy(() => import('../pages/admin/email/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/platforms',
    element: <Platforms />
  },
  {
    path: '/features',
    element: <Features />
  },
  {
    path: '/resources',
    element: <Resources />
  },
  {
    path: '/marketplace',
    element: <Marketplace />
  },
  {
    path: '/partners',
    element: <Partners />
  },
  {
    path: '/support',
    element: <Support />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/about',
    element: <About />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/admin',
    element: <Navigate to="/admin/content" replace />
  },
  {
    path: '/admin/content',
    element: <AdminContent />
  },
  {
    path: '/admin/news',
    element: <AdminNews />
  },
  {
    path: '/admin/email',
    element: <AdminEmail />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
